import styled from 'styled-components';
import DefaultTab from 'components/Tab';
import DefaultAvatar from 'components/Avatar';
import { Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import {
  FiUser as UserIcon,
  FiMapPin as IconLocation,
  FiPhone as IconPhone,
  FiClock as IconClock,
  FiHash as IconHash,
} from 'react-icons/fi';
import IconOrder from 'assets/icons/orders.svg?react';

export const Container = styled.div`
  height: fit-content;
`;

export const Tabs = styled.nav`
  display: flex;
  margin-bottom: 1.5rem;
`;

export const Tab = styled(DefaultTab)`
  :not(:last-child) {
    margin-right: 1rem;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 2rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  :not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

export const Avatar = styled(DefaultAvatar)`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
`;

export const Text = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
`;

export const LocationText = styled(Text)`
  margin-top: 0.25rem;
`;

export const TextGrey = styled(Body)`
  margin-left: 0.25rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

export const OrderIcon = styled(IconOrder)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const HashIcon = styled(IconHash)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const ClockIcon = styled(IconClock)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const PhoneIcon = styled(IconPhone)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const LocationIcon = styled(IconLocation)`
  align-self: flex-start;
  width: 1.5rem;
  height: 1.5rem;
`;

export const WarnCard = styled.div`
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.redExtraLight};
  min-height: 4rem;
  padding: 1.375rem 2rem 1.125rem 2rem;
`;

export const WarnText = styled(Body)`
  font-size: 1.0625rem;
  color: ${({ theme }) => theme.colors.redMedium};
  span {
    font-weight: 600;
  }
`;

export const IconUser = styled(UserIcon)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const WrapperIcon = styled.div`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  display: flex;
  justify-content: center;
  align-items: center;
`;
